<div class="topbar row w-100 g-0">

  <div class="col-6 col-md-6 d-flex align-items-center justify-content-start">

    <div class="col-auto col-lg-3 d-flex">
      <img src="assets/caffer-logo-full.svg" alt="Logo" routerlink="/" class="logo" tabindex="0"
        ng-reflect-router-link="/" />
    </div>


    <button class="section-button" (click)="goToNewService()">
      <img src="/assets/icons/plus-circle-black-fill.svg" alt="" />
      <div class="section-button-text d-none d-md-block">{{ 'request_service' | translate }}</div>
    </button>


  </div>

  <div class="col-6 col-md-6 col-lg-6 d-flex align-items-center  justify-content-end">

    <div class="d-flex align-items-center gap-1 gap-md-3 gap-lg-4 me-1">

      <app-notifications></app-notifications>

      <div class="question-mark">

        <div class="icon-container" [class.selected]="isSelected" (mouseover)="onHover(true)"
          (mouseleave)="onHover(false)" (click)="onSelect()">
          <img class="icon black" src="../../assets/icons/question-mark-circle.svg" alt="Default Icon"
            (click)="toggleQuestion()" />
          <img class="icon hover" src="../../assets/icons/question-mark-circle-hover.svg" alt="Hover Icon" />
          <img class="icon selected" src="../../assets/icons/question-mark-circle-green.svg" alt="Selected Icon"
            (click)="toggleQuestion()" />
        </div>

        <div class="dropdown-help" [class.show]="isQuestionOpen">
          <div class="dropdown-item" (click)="redirectHelp()">
            <div class="item-icon">
              <img src="../../assets/icons/question-mark-circle.svg" />
            </div>
            <span class="item-text">{{ 'helpCenter' | translate }}</span>
          </div>
          <div class="dropdown-item" (click)="redirectTutorials()">
            <div class="item-icon">
              <img src="../../assets/icons/video-camera.svg" />
            </div>
            <span class="item-text">{{ 'tutorials' | translate }}</span>
          </div>
          <div class="dropdown-item" (click)="openModal($event)">
            <div class="item-icon">
              <img src="../../assets/icons/chat.svg" />
            </div>
            <span class="item-text">{{ 'contactSupport' | translate }}</span>
          </div>
        </div>

      </div>

    </div>

    <div class="profile-card">

      <div class="profile-info">
        <p class="profile-name">{{ userName }}</p>
        <p class="profile-email">{{ userEmail }}</p>
      </div>

      <div class="profile-avatar">
        <div class="button-arrow" [ngClass]="{ rotated: isRotated }" (click)="toggleDropdown()">
          <img src="../../assets/icons/chevron-left-dark.svg" alt="" />
        </div>
        <img src="{{ userImg }}" alt="User Avatar" />
      </div>

      <div class="dropdown " [ngClass]="{ show: isDropdownOpen }">
        <div class="dropdown-item" [routerLink]="['/my-account']">
          <div class="item-icon">
            <img src="../../assets/icons/user-icon.svg">
          </div>
          <span class="item-text">{{ 'my_profile' | translate }}</span>
        </div>
        <div class="dropdown-item" [routerLink]="['/settings']">
          <div class="item-icon">
            <img src="../../assets/icons/settings-icon.svg">
          </div>
          <span class="item-text">{{ 'settings' | translate }}</span>
        </div>
        <div class="dropdown-item logout" (click)="logout()">
          <div class="item-icon">
            <img src="../../assets/icons/logout-icon.svg">
          </div>
          <span class="item-text">{{ 'logout' | translate }}</span>
        </div>
      </div>

    </div>

  </div>

</div>